<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="measurements"
      sort-by="gtin"
      :search="search"
      class="elevation-0 general-table"
      :loading="isLoading"
      :calculate-widths="true"
      @click:row="rowClick"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.created_at="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-TIMESTAMP"></lang></span>
      </template>

      <template v-slot:header.name="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-NAME"></lang></span>
      </template>

      <template v-slot:header.sensorType="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-SENSOR_TYPE"></lang></span>
      </template>

      <template v-slot:header.stationId="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-STATION_ID"></lang></span>
      </template>

      <template v-slot:header.sensor_value="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-SENSOR_VALUE"></lang></span>
      </template>

      <template v-slot:header.genomix_value="{ header }">
        <span class="measurements-table__th-text"><lang t="MEASUREMENTS-TBL-HEADER-GENOMIX_VALUE"></lang></span>
      </template>

      <template v-slot:footer.page-text="props" v-if="(measurements.length > 0)">
      <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
      <display-number :number="measurements.length" />
    </template>


      <template v-slot:top>
        <div class="d-flex align-center flex-wrap py-2 mb-3">
          <v-text-field
            clearable
            background-color="#fff"
            style="max-width: 400px; min-width: 200px; border: 1px solid #cdcdcd;"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            solo
            flat
            dense
            hide-details
          >
          </v-text-field>
        </div>
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at }}

      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small @click.stop="editItem(item)">mdi-pencil</v-icon>
      </template>

      <template v-slot:no-data>
        Keine Daten vorhanden
      </template>
    </v-data-table>

    <v-dialog v-model="dialog.show" :max-width="dialog.maxSize + 'px'" :persistent="false">
      <v-card>
        <v-card-title>
          <span class="headline"><lang :t="dialog.title"></lang></span>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DisplayNumber from '../../components/DisplayNumber.vue';
export default {
  props: {
    warehouseId: {
      type: Number,
      required: true,
    },
  },
  components:{
    DisplayNumber
  },
  data: () => ({
    dialog: {
      show: false,
      title: "",
      type: "",
    },
    isSaving: false,
    isLoading: true,
    search: "",

    headers: [
      {
        text: "createdAt",
        value: "created_at",
        sortable: true,
        class: 'general-table__th--6'
      },
      {
        text: "name",
        sortable: true,
        value: "name",
        class: 'general-table__th--6'
      },
      { text: "sensorType", value: "sensorType", sortable: false, class: 'general-table__th--6' },
      { text: "stationId", value: "stationId", sortable: false, class: 'general-table__th--6' },
      { text: "sensorValue", value: "sensor_value", sortable: false, class: 'general-table__th--6' },
      { text: "genomixValue", value: "genomix_value", sortable: false, class: 'general-table__th--6' },
    ],

    measurements: [],
  }),

  computed: {},

  watch: {
    "dialog.show"(val) {
      val || this.closeModal();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    exportArticles() {},

    importArticles() {},

    showModal(type) {
      this.dialog.type = type;

      switch (type) {
        case "export":
          this.dialog.title = "ARTICLES-EXPORT-TITLE";
          this.dialog.maxSize = "640";
          break;

        case "import":
          this.dialog.title = "ARTICLES-IMPORT-TITLE";
          this.dialog.maxSize = "1024";
          break;
      }

      this.dialog.show = true;
    },

    closeModal() {
      this.dialog.show = false;
    },

    initialize() {
      this.axios.post("measurements/query", { warehouse_id: this.warehouseId }).then((res) => {
        this.measurements = res.data;
        this.isLoading = false;
      });
    },

    rowClick(item) {
      this.editItem(item);
    },

    editItem(item) {
      this.$router.push({ name: "article", params: { id: item.id } });
    },

    deleteItem(item) {
      const index = this.articles.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.articles.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.measurements-table {
    &__th-text{
        text-transform: uppercase;
    }

  & table {
    border: 1px solid #cdcdcd;
    &.v-data-table::v-deep > table > td {
      border-bottom: 1px solid #cdcdcd !important;
    }
  }
}

.theme--light.v-data-table .v-data-table__wrapper table thead.v-data-table-header {
  height: 40px !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid #cdcdcd !important;
}
</style>
